import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';

export default function BusinessesAnimation() {
  const rocket = useAnimation();
  const rocketTop = useAnimation();
  const sunLeft = useAnimation();
  const sunRight = useAnimation();
  const cloudLeft = useAnimation();
  const cloudRight = useAnimation();
  const rectanlge = useAnimation();

  useEffect(() => {
    rocket.start((i) => ({
      y: 0,
      transition: { delay: i * 0.1, duration: 1.5 },
    }));
  }, [rocket]);

  rocketTop.start({
    rotate: 0,
    y: 0,
    x: 0,
    transition: { delay: 1, duration: 8 },
  });

  rectanlge.start({
    y: 5,
    transition: { delay: 1, duration: 1.5 },
  });

  sunLeft.start({
    opacity: [0, 0, 1, 1, 1, 1, 1],
    x: [0, 0, 0, -5, -10, -15, -20],
    transition: { ease: 'linear', delay: 0.8, duration: 10 },
  });

  sunRight.start({
    opacity: 1,
    transition: { delay: 1.5, duration: 2 },
  });

  cloudLeft.start({
    opacity: [0, 0.5, 1, 1, 1, 1, 1, 1, 1, 1],
    x: [10, 20, 30, 20, 10, 0, 10, 20, 30, 20],
    transition: { ease: 'linear', delay: 0.8, duration: 10 },
  });

  cloudRight.start({
    opacity: [0, 0.5, 1, 1, 1, 1, 1, 1, 1, 1],
    x: [10, 20, 30, 20, 10, 0, 10, 20, 30, 20],
    transition: { ease: 'linear', delay: 0.3, duration: 10 },
  });

  return (
    <svg viewBox="0 0 618 460" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Engineer your perfect team with Terminal, developers building a rocketship</title>
      <motion.g id="left-box" custom={0} animate={rocket} initial={{ y: 230 }}>
        <path d="M306.201 224.2H34.7012V459H306.201V224.2Z" fill="#DCE4E7" />
        <path
          d="M306.9 459.7H33.9004V223.4H306.9V459.7ZM35.4004 458.2H305.4V224.9H35.4004V458.2Z"
          fill="#25383F"
        />
      </motion.g>
      <motion.g id="right-box" custom={3} animate={rocket} initial={{ y: 150 }}>
        <path d="M590.401 311.3H437.801V459.2H590.401V311.3Z" fill="#DCE4E7" />
        <path
          d="M591.1 459.9H437V310.5H591.1V459.9ZM438.5 458.4H589.6V312H438.5V458.4Z"
          fill="#25383F"
        />
      </motion.g>
      <path
        d="M307.401 459.7H69.8008C72.1008 396.1 124.401 345.3 188.601 345.3C252.801 345.3 305.101 396.1 307.401 459.7Z"
        fill="#F5AE2D"
      />
      <motion.path
        id="sun-left"
        animate={sunLeft}
        initial={{ opacity: 0 }}
        d="M178.3 160.1C186.694 160.1 193.5 153.295 193.5 144.9C193.5 136.505 186.694 129.7 178.3 129.7C169.905 129.7 163.1 136.505 163.1 144.9C163.1 153.295 169.905 160.1 178.3 160.1Z"
        fill="#F5AE2D"
      />
      <motion.path
        id="sun-right"
        animate={sunRight}
        initial={{ opacity: 0 }}
        d="M538.8 142.7C565.199 142.7 586.6 121.299 586.6 94.8998C586.6 68.5006 565.199 47.0999 538.8 47.0999C512.401 47.0999 491 68.5006 491 94.8998C491 121.299 512.401 142.7 538.8 142.7Z"
        fill="#F5AE2D"
      />
      <motion.g id="cloud-right" animate={cloudRight} initial={{ opacity: 0 }}>
        <path
          d="M410.699 116.1H570.899C570.899 116.1 555.199 84.1998 510.899 94.9998C510.999 94.9998 448.099 34.0998 410.699 116.1Z"
          fill="#DDE6E9"
        />
        <path
          d="M572.2 116.8H409.6L410.1 115.7C421.4 90.8999 436.2 76.5999 454.1 73.1999C481.9 67.8999 508.2 91.1999 511.3 94.0999C555.3 83.5999 571.6 115.4 571.7 115.7L572.2 116.8ZM411.9 115.3H569.7C566.4 109.9 549.7 86.2999 511.2 95.6999L510.8 95.7999L510.5 95.4999C510.2 95.1999 483 69.2999 454.3 74.6999C437.2 77.9999 422.9 91.6998 411.9 115.3Z"
          fill="black"
        />
      </motion.g>
      <motion.g id="cloud-left" animate={cloudLeft} initial={{ opacity: 0 }}>
        <path
          d="M103.4 43H194C194 43 185.1 25 160.1 31.1C160.1 31.1 124.5 -3.29999 103.4 43Z"
          fill="#DDE6E9"
        />
        <path
          d="M195.201 43.7999H102.301L102.801 42.6999C109.201 28.5999 117.701 20.3999 127.901 18.4999C136.701 16.7999 145.201 20.2 150.701 23.3C155.801 26.2 159.301 29.2999 160.401 30.1999C185.401 24.2999 194.701 42.4 194.701 42.6L195.201 43.7999ZM104.601 42.2999H192.701C191.701 40.7999 189.501 37.8999 185.901 35.3999C179.101 30.6999 170.201 29.3999 160.301 31.8999L159.901 31.9999L159.601 31.6999C159.401 31.5999 144.201 17 128.101 20.1C118.601 21.8 110.701 29.2999 104.601 42.2999Z"
          fill="black"
        />
      </motion.g>
      <path d="M210.499 193H122.199V160.6H210.499V193Z" fill="white" />
      <path
        d="M208.999 162V191.4H123.699V162H208.999ZM210.499 160.5H122.199V193H210.499V160.5Z"
        fill="#25383F"
      />
      <path d="M618 458.5H0V460H618V458.5Z" fill="#25383F" />
      <path
        d="M501.999,427.6 C501.699,427.6 501.399,427.4 501.299,427.1 C501.199,426.7 501.399,426.3 501.699,426.1 C521.699,418.7 532.999,407.3 535.399,392.1 C544.499,334.2 423.399,238.5 422.099,237.6 L421.999,237.5 L406.899,217.7 L314.299,10.4998 L301.799,10.9998 L302.6,458.6 C302.4,459 302,459.1 301.6,459 C301.2,458.8 301.1,458.4 301.2,458 L300.799,9.3998 L315.199,8.7998 L408.199,216.8 L423.099,236.3 C424.799,237.7 454.799,261.5 483.399,291.8 C522.799,333.7 540.799,367.5 536.899,392.2 C534.399,408 522.799,419.9 502.299,427.4 C502.199,427.6 502.099,427.6 501.999,427.6 Z"
        fill="#90B667"
      />
      <motion.rect
        x="296"
        y="51"
        width="10"
        height="64"
        fill="#FFFFFF"
        animate={rectanlge}
        initial={{ y: 420 }}
      />
      <motion.g id="rocket" custom={2} animate={rocket} initial={{ y: 420 }}>
        <motion.path
          id="rocket-top"
          animate={rocketTop}
          initial={{ rotate: 54, y: 18, x: 30 }}
          d="M230.1 39.9C230.1 39.9 242.2 89.1 265.6 114.8L312.2 52C280.8 37.2 230.1 39.9 230.1 39.9Z"
          fill="#25393F"
        />
        <path
          d="M252.2 344.5L212.7 377.9L201.6 459.5H212.7L283.7 429L252.2 344.5Z"
          fill="#25393F"
        />
        <path
          d="M360.299 344.5L399.799 377.9L410.899 459.5H399.799L328.799 429L360.299 344.5Z"
          fill="#25393F"
        />
        <path
          d="M339 431.7L274.1 431.5L273.6 430.5C256.6 393 245.5 353 240.8 311.7C237 278.7 237.2 244.8 241.3 210.9C248.4 153.2 264.9 115 265.1 114.7L265.6 113.7L347.7 113.9L348.1 114.9C348.3 115.3 364.7 153.4 371.9 211.1C376.1 245 376.3 278.9 372.4 311.9C367.6 353.2 356.6 393.1 339.5 430.7L339 431.7Z"
          fill="white"
        />
        <path
          d="M339.5 432.4L273.6 432.2L272.9 430.8C255.8 393.2 244.7 353.1 239.9 311.8C236.1 278.7 236.3 244.8 240.4 210.8C247.5 153.1 264 114.7 264.2 114.4L264.8 112.9L347.9 113.1L348.5 114.6C348.7 115 365.2 153.2 372.3 211C376.5 244.9 376.7 278.9 372.8 312C368 353.3 356.9 393.4 339.8 431L339.5 432.4ZM274.6 430.8L338.5 431L338.8 430.4C355.8 392.9 366.9 353 371.6 311.8C375.4 278.8 375.2 245 371.1 211.2C364 153.5 347.6 115.6 347.4 115.2L347.1 114.6L266 114.4L265.7 115C265.5 115.4 249.1 153.5 242 211C237.8 244.8 237.7 278.7 241.5 311.6C246.3 352.8 257.3 392.7 274.3 430.2L274.6 430.8Z"
          fill="#25383F"
        />
        <path d="M313.6 346.9H299V459.6H313.6V346.9Z" fill="#25383F" />
        <path
          d="M306.2 261.7C312.054 261.7 316.8 256.954 316.8 251.1C316.8 245.246 312.054 240.5 306.2 240.5C300.345 240.5 295.6 245.246 295.6 251.1C295.6 256.954 300.345 261.7 306.2 261.7Z"
          fill="#25383F"
        />
        <path
          d="M306.2 300.1C312.054 300.1 316.8 295.354 316.8 289.5C316.8 283.646 312.054 278.9 306.2 278.9C300.345 278.9 295.6 283.646 295.6 289.5C295.6 295.354 300.345 300.1 306.2 300.1Z"
          fill="#25383F"
        />
        <path
          d="M277.1 127.4C278.592 127.4 279.8 126.191 279.8 124.7C279.8 123.209 278.592 122 277.1 122C275.609 122 274.4 123.209 274.4 124.7C274.4 126.191 275.609 127.4 277.1 127.4Z"
          fill="#25383F"
        />
        <path
          d="M281.2 422.7C282.691 422.7 283.9 421.491 283.9 420C283.9 418.509 282.691 417.3 281.2 417.3C279.709 417.3 278.5 418.509 278.5 420C278.5 421.491 279.709 422.7 281.2 422.7Z"
          fill="#25383F"
        />
        <path
          d="M292.2 422.7C293.691 422.7 294.9 421.491 294.9 420C294.9 418.509 293.691 417.3 292.2 417.3C290.709 417.3 289.5 418.509 289.5 420C289.5 421.491 290.709 422.7 292.2 422.7Z"
          fill="#25383F"
        />
        <path
          d="M320.3 422.7C321.791 422.7 323 421.491 323 420C323 418.509 321.791 417.3 320.3 417.3C318.808 417.3 317.6 418.509 317.6 420C317.6 421.491 318.808 422.7 320.3 422.7Z"
          fill="#25383F"
        />
        <path
          d="M331.3 422.7C332.791 422.7 334 421.491 334 420C334 418.509 332.791 417.3 331.3 417.3C329.808 417.3 328.6 418.509 328.6 420C328.6 421.491 329.808 422.7 331.3 422.7Z"
          fill="#25383F"
        />
        <path
          d="M288.7 127.4C290.191 127.4 291.4 126.191 291.4 124.7C291.4 123.209 290.191 122 288.7 122C287.209 122 286 123.209 286 124.7C286 126.191 287.209 127.4 288.7 127.4Z"
          fill="#25383F"
        />
        <path
          d="M300.2 127.4C301.691 127.4 302.9 126.191 302.9 124.7C302.9 123.209 301.691 122 300.2 122C298.709 122 297.5 123.209 297.5 124.7C297.5 126.191 298.709 127.4 300.2 127.4Z"
          fill="#25383F"
        />
        <path
          d="M311.8 127.4C313.291 127.4 314.5 126.191 314.5 124.7C314.5 123.209 313.291 122 311.8 122C310.308 122 309.1 123.209 309.1 124.7C309.1 126.191 310.308 127.4 311.8 127.4Z"
          fill="#25383F"
        />
        <path
          d="M323.399 127.4C324.89 127.4 326.099 126.191 326.099 124.7C326.099 123.209 324.89 122 323.399 122C321.908 122 320.699 123.209 320.699 124.7C320.699 126.191 321.908 127.4 323.399 127.4Z"
          fill="#25383F"
        />
        <path
          d="M334.999 127.4C336.49 127.4 337.699 126.191 337.699 124.7C337.699 123.209 336.49 122 334.999 122C333.508 122 332.299 123.209 332.299 124.7C332.299 126.191 333.508 127.4 334.999 127.4Z"
          fill="#25383F"
        />
        <path d="M355.8 134.4H257.4V135.9H355.8V134.4Z" fill="#25383F" />
        <path d="M356 408.2H257.6V409.7H356V408.2Z" fill="#25383F" />
        <path
          d="M306.3 225.3C289.6 225.3 276 211.7 276 195C276 178.3 289.6 164.7 306.3 164.7C323 164.7 336.6 178.3 336.6 195C336.7 211.7 323.1 225.3 306.3 225.3Z"
          fill="#6DA7BB"
        />
      </motion.g>
      <path
        d="M514.799 250.9L515.999 232.9C515.999 232.9 500.599 233.4 513.799 208.1L534.799 216.3L530.899 230.1L531.899 251.1L514.799 250.9Z"
        fill="white"
      />
      <path
        d="M532.599 251.8L513.999 251.7L515.199 233.6C513.799 233.5 510.799 232.8 509.099 230C506.399 225.6 507.699 218.1 513.099 207.7L513.399 207.1L535.599 215.8L531.499 230.2L532.599 251.8ZM515.599 250.2L531.099 250.3L530.099 230L533.899 216.7L514.199 209C508.099 220.9 508.799 226.5 510.399 229.2C512.299 232.2 515.899 232.2 516.099 232.1H516.899L515.599 250.2Z"
        fill="#25383F"
      />
      <path
        d="M523.899 218.8C523.899 218.8 526.199 215 528.599 217.7C529.599 218.9 529.5 222 525.5 223C525.5 223 524.399 229.9 531.399 231.1C531.399 231.1 540.8 222.8 538.5 212.6C538.5 212.6 550.399 216.4 553.099 205.6C553.899 202.3 552.2 195.9 545 194.9C541.4 194.4 534.7 195.7 534 204.3C534 204.3 515.9 193.8 511.5 210C511.4 210 516.399 218 523.899 218.8Z"
        fill="#25383F"
      />
      <path
        d="M396.5 435.5C396.5 435.5 411.2 454 423.1 451.6L424.5 447.8L402.2 433.1L396.5 435.5Z"
        fill="#F5AE2D"
      />
      <path
        d="M491.299 314.9C491.299 314.9 530.399 341.1 549.899 331.6L545.299 317.8L500.099 308.3L491.299 314.9Z"
        fill="#F5AE2D"
      />
      <path
        d="M554.8 441.6C554.8 441.6 569.1 434 568.6 411.7L561.5 407.4L549.1 435L554.8 441.6Z"
        fill="#F5AE2D"
      />
      <path
        d="M368.998 459.3L369.698 457.7C372.698 451 383.698 448.2 390.298 446.6C391.398 446.3 392.398 446.1 393.198 445.8C401.598 443.3 403.598 431.1 403.598 431L403.898 429.3L422.798 440.3L413.398 459.2L368.998 459.3Z"
        fill="white"
      />
      <path
        d="M367.799 460L368.999 457.3C372.199 450.3 383.399 447.5 390.099 445.8C391.199 445.5 392.199 445.3 392.999 445C400.899 442.7 402.799 430.9 402.899 430.8L403.299 428.1L423.799 440L413.899 459.9L367.799 460ZM404.399 430.5L404.299 431.1C404.199 431.6 402.199 444 393.399 446.5C392.599 446.7 391.599 447 390.499 447.3C384.099 448.9 373.299 451.7 370.399 458L370.099 458.6L412.899 458.5L421.799 440.6L404.399 430.5Z"
        fill="#25383F"
      />
      <path
        d="M557.2 418.2L577 426.1L578.1 459.2H557.7C557.7 459.2 560.7 453.6 565.6 452.8C565.6 452.8 562.2 437.5 552.4 431.9L557.2 418.2Z"
        fill="white"
      />
      <path
        d="M578.9 460H556.5L557.1 458.9C557.2 458.7 560 453.5 564.8 452.3C564 449.2 560.4 437.3 552.1 432.7L551.6 432.4L556.8 417.3L577.8 425.7V426.2L578.9 460ZM559.1 458.5H577.3L576.2 426.6L557.6 419.1L553.3 431.6C562.9 437.5 566.2 452 566.4 452.6L566.6 453.4L565.8 453.5C562.6 454.1 560.2 456.9 559.1 458.5Z"
        fill="#25383F"
      />
      <path
        d="M496.3 308.3L494.5 382.9C494.3 391.3 498.199 399.4 504.899 404.5L554.5 442C554.5 442 554.699 431.3 557.599 424.7C560.6 417.8 567.8 411.6 567.8 411.6L525.5 376.5L538.2 316.2L496.3 308.3Z"
        fill="#25393F"
      />
      <path
        d="M493.7 312.3L537.7 315.9C537.7 315.9 541 322.5 483 375.2L423.1 451.6C423.1 451.6 418.3 442.6 411.2 439.3C405.2 436.5 396.5 435.5 396.5 435.5L445.7 365.9C447.5 363.4 449.4 361 451.4 358.8L493.7 312.3Z"
        fill="#25393F"
      />
      <path
        d="M493.899 367.3C493.699 367.3 493.499 367.2 493.399 367.1C493.099 366.8 493.099 366.3 493.399 366C520.399 340.8 535.199 324.1 535.299 323.9C535.599 323.6 535.999 323.6 536.399 323.8C536.699 324.1 536.699 324.5 536.499 324.9C536.399 325.1 521.299 342 494.499 367.1C494.199 367.2 494.099 367.3 493.899 367.3Z"
        fill="#DDE6E9"
      />
      <path
        d="M496.298 265.1C496.298 265.1 495.998 280.6 496.298 284.6C497.298 298.4 489.398 316.2 489.398 316.2C489.398 316.2 505.298 315.5 519.098 318.8C534.598 322.5 548.998 329.7 548.998 329.7L549.198 259.4C549.198 254.5 546.898 249.9 542.998 246.9L532.098 238.8C532.098 238.8 518.098 254.7 513.998 239.7L474.498 241.6L475.698 264.1L496.298 265.1Z"
        fill="#FFDC81"
      />
      <path
        d="M549.799 330.9L548.699 330.4C548.599 330.3 534.099 323.2 518.899 319.5C505.399 316.2 489.599 316.9 489.399 316.9L488.199 317L488.699 315.9C488.799 315.7 496.499 298.1 495.499 284.7C495.299 281.2 495.399 269.1 495.499 265.9L475.099 265L473.799 241L514.599 239L514.799 239.6C515.699 242.9 517.199 244.9 519.199 245.3C524.299 246.5 531.499 238.4 531.599 238.3L532.099 237.8L543.499 246.3C547.599 249.4 549.999 254.3 549.999 259.4L549.799 330.9ZM493.099 315.3C498.699 315.3 509.599 315.6 519.299 318C532.299 321.1 544.699 326.7 548.299 328.5L548.499 259.4C548.499 254.7 546.299 250.3 542.599 247.5L532.299 239.8C530.499 241.7 524.099 248 518.899 246.7C516.499 246.1 514.699 244 513.599 240.5L475.499 242.3L476.599 263.4L497.099 264.4V265.1C497.099 265.3 496.799 280.6 497.099 284.5C497.899 296.5 492.299 311.2 490.599 315.3C491.199 315.3 491.999 315.3 493.099 315.3Z"
        fill="#25393F"
      />

      <path
        d="M530.4 303.3C529.3 303.3 528.2 303.1 527.2 302.7L483.7 285.4L479.3 284.2C476.4 283.4 472.2 285.9 470.3 283.6L461.3 276C459.9 274.8 459.4 272.7 460.2 271C461.1 269 463.3 268.1 465.4 268.8L485.1 275.5L522.2 283.9L523.5 272.5L543.8 276.9L539 296.6C538.4 299.1 536.8 301.1 534.5 302.3C533.1 303 531.8 303.3 530.4 303.3Z"
        fill="white"
      />
      <path
        d="M530.4 304C529.2 304 528 303.8 526.9 303.3L483.4 286L479 284.8C478 284.5 476.6 284.7 475.3 284.9C473.2 285.2 471 285.6 469.6 284L460.7 276.5C459 275.1 458.5 272.6 459.4 270.6C460.5 268.3 463.1 267.2 465.5 268L485.2 274.7L521.4 282.9L522.7 271.5L544.5 276.3L539.5 296.8C538.9 299.5 537.1 301.7 534.6 303C533.4 303.7 531.9 304 530.4 304ZM477.8 283.2C478.3 283.2 478.9 283.3 479.4 283.4L483.8 284.6L527.4 301.9C529.5 302.7 532 302.6 534 301.6C536.1 300.5 537.5 298.6 538.1 296.4L542.7 277.4L524 273.3L522.7 284.7L484.8 276.1L465 269.4C463.3 268.8 461.5 269.6 460.7 271.2C460 272.6 460.4 274.3 461.6 275.3L470.6 282.9C471.5 283.9 473.1 283.6 475 283.3C476 283.3 476.9 283.2 477.8 283.2Z"
        fill="#25383F"
      />
      <path
        d="M307.999 16.9999C303.399 16.9999 299.699 13.2999 299.699 8.69991C299.699 4.09991 303.399 0.399902 307.999 0.399902C312.599 0.399902 316.299 4.09991 316.299 8.69991C316.299 13.2999 312.599 16.9999 307.999 16.9999Z"
        fill="white"
      />
      <path
        d="M307.999 1.8999C311.799 1.8999 314.799 4.99991 314.799 8.69991C314.799 12.3999 311.699 15.4999 307.999 15.4999C304.299 15.4999 301.199 12.3999 301.199 8.69991C301.199 4.99991 304.299 1.8999 307.999 1.8999ZM307.999 0.399902C303.399 0.399902 299.699 4.09991 299.699 8.69991C299.699 13.2999 303.399 16.9999 307.999 16.9999C312.599 16.9999 316.299 13.2999 316.299 8.69991C316.299 4.09991 312.599 0.399902 307.999 0.399902Z"
        fill="#25383F"
      />
      <path
        d="M475.099 259.5L466.699 257.7C463.399 257.4 460.199 256.5 457.299 255L421.799 236.4L407.399 227.4C406.399 226.8 405.799 225.6 405.999 224.4L406.699 217.8C406.799 217 407.499 216.4 408.199 216.5L414.999 216.7C415.499 216.7 415.999 217 416.199 217.4L423.699 229.2L462.099 241.7L474.499 242.1L475.099 259.5Z"
        fill="white"
      />
      <path
        d="M475.899 260.4L466.599 258.4C463.299 258.1 459.999 257.2 456.999 255.6L421.499 237L407.099 228C405.799 227.2 405.099 225.8 405.299 224.3L405.999 217.7C406.099 216.5 407.099 215.7 408.299 215.7L415.099 215.9C415.899 215.9 416.599 216.3 416.999 216.9L424.299 228.4L462.299 240.7L475.299 241.1L475.899 260.4ZM408.299 217.3C407.899 217.3 407.599 217.6 407.499 218L406.799 224.6C406.699 225.5 407.099 226.4 407.899 226.9L422.299 235.9L457.799 254.4C460.599 255.9 463.699 256.8 466.899 257.1L474.399 258.7L473.999 242.9L462.099 242.5L423.499 230L415.899 218C415.799 217.8 415.499 217.7 415.299 217.6L408.299 217.3Z"
        fill="#25383F"
      />
      <path
        d="M496.198 271.1C495.798 271.1 495.398 270.8 495.398 270.3L495.698 255.3C495.698 254.9 495.998 254.6 496.498 254.6C496.898 254.6 497.198 254.9 497.198 255.4L496.898 270.4C496.998 270.8 496.598 271.1 496.198 271.1Z"
        fill="#25383F"
      />
      <path
        d="M543.7 277.5C543.6 277.5 543.6 277.5 543.5 277.5C543.1 277.4 542.9 277 543 276.6L548.5 258.8C548.6 258.4 549 258.2 549.4 258.3C549.8 258.4 550 258.8 549.9 259.2L544.4 277C544.4 277.3 544.1 277.5 543.7 277.5Z"
        fill="#25383F"
      />
      <path
        d="M523.299 274.2C523.299 274.2 523.199 274.2 523.299 274.2C522.799 274.1 522.499 273.8 522.599 273.4L523.899 263.3C523.999 262.9 524.299 262.6 524.699 262.6C525.099 262.7 525.399 263 525.399 263.4L524.099 273.5C523.999 273.9 523.699 274.2 523.299 274.2Z"
        fill="#25383F"
      />
      <path d="M119.8 110.9H60.4004V88.9998H119.8V110.9Z" fill="#90B667" />
      <path
        d="M120.5 111.6H59.5996V88.2998H120.5V111.6ZM61.0996 110.1H119V89.7998H61.0996V110.1Z"
        fill="#25383F"
      />
      <path
        d="M81.8999 354.5C76.6999 353.6 76.9999 343.7 75.1999 339.9C69.4999 328 80.1999 313.6 80.7999 312.6L81.2999 311.9L101 316.8L93.6999 330.6C100.6 334 137.7 352.3 144.7 354.8C152.8 357.7 158 366.8 157.1 366.6L156.7 366.5C156.3 366.4 116.9 350 87.3999 347C86.6999 347 82.3999 354.6 81.8999 354.5Z"
        fill="white"
      />
      <path
        d="M157.001 367.4C156.901 367.4 156.901 367.4 156.801 367.4L156.4 367.3C156.3 367.3 156.301 367.3 155.301 366.9C139.901 360.8 110.701 350.3 87.5005 347.9C87.0005 348.4 85.9005 350.1 85.2005 351.3C82.7005 355 82.4005 355.4 81.8005 355.3C77.7005 354.6 76.6005 349.3 75.8005 345C75.4005 343.2 75.1005 341.4 74.6005 340.3C69.5005 329.6 76.8005 317.3 80.1005 312.5L81.0005 311.2L102.201 316.5L94.8005 330.4C103.401 334.7 138.201 351.8 145.001 354.2C152.901 357 158.401 365.5 158.001 366.9C157.701 367.2 157.401 367.4 157.001 367.4ZM87.2005 346.3H87.3005C110.801 348.7 140.301 359.3 155.801 365.4C154.401 362.9 150.001 357.5 144.301 355.4C137.201 352.9 100.501 334.8 93.2005 331.2L92.5005 330.9L99.7005 317.3L81.4005 312.7L81.1005 313.2C77.9005 317.8 71.0005 329.6 75.7005 339.5C76.3005 340.8 76.7005 342.6 77.1005 344.5C77.9005 348.4 78.8005 352.8 81.6005 353.6C82.1005 353.1 83.1005 351.5 83.8005 350.4C86.2005 346.9 86.7005 346.3 87.2005 346.3Z"
        fill="#25393F"
      />
      <path
        d="M244.8 368.9C244.8 370.6 242.9 371.6 241.5 370.7L232.4 362L216.8 355.9L185.4 341.5C183.2 340.5 181.2 339.2 179.3 337.8L157 320.1L171.1 308.7L192.8 329.2L224 348.6C225.2 349.7 238.4 351.6 243.3 362L244.8 368.9Z"
        fill="white"
      />
      <path
        d="M242.601 371.8C242.101 371.8 241.601 371.7 241.101 371.4L241.001 371.3L232.001 362.7L216.601 356.7L185.101 342.3C182.901 341.3 180.801 340 178.801 338.5L155.801 320.2L171.101 307.8L193.201 328.7L224.401 348.1C224.601 348.2 225.501 348.6 226.401 348.8C230.801 350.3 239.901 353.3 243.901 361.7L244.001 361.8L245.701 368.8V368.9C245.701 370 245.101 370.9 244.201 371.4C243.601 371.7 243.101 371.8 242.601 371.8ZM241.901 370.1C242.301 370.3 242.801 370.3 243.301 370.1C243.701 369.9 244.001 369.4 244.001 369L242.401 362.3C238.701 354.5 230.001 351.7 225.801 350.3C224.401 349.8 223.701 349.6 223.401 349.3L192.201 329.8L171.001 309.7L158.201 320.1L179.701 337.2C181.501 338.6 183.501 339.9 185.601 340.8L217.001 355.2L232.701 361.3L241.901 370.1Z"
        fill="#25383F"
      />
      <path
        d="M133.801 287L146.101 268.3L157.601 252.7L173.901 262.8C173.901 262.8 170.101 292.7 156.001 282.4L150.101 293.4L133.801 287Z"
        fill="white"
      />
      <path
        d="M150.701 294.6L132.301 287.5L145.301 267.7L157.401 251.3L175.101 262.2L175.001 262.8C174.901 263.6 172.501 281.4 164.501 284.9C162.001 286 159.301 285.6 156.501 283.8L150.701 294.6ZM135.301 286.5L149.801 292.1L155.801 280.9L156.701 281.6C159.301 283.5 161.601 284 163.701 283.1C169.901 280.4 172.401 266.4 172.901 263.3L157.901 254L146.901 268.9L135.301 286.5Z"
        fill="#25383F"
      />
      <path
        d="M181.101 265.7C182.801 262.3 178.001 259.5 178.001 259.5C179.901 259.9 180.801 259.3 181.101 258.5C182.801 254.2 173.101 252.9 173.101 252.9C175.601 252.1 173.301 250.4 173.301 250.4C170.401 248.6 164.001 248.1 159.401 248C158.101 247.4 141.701 240.7 143.501 270.4C143.501 270.4 151.101 276.8 155.901 268.4C155.901 268.4 155.501 262.9 159.801 264C160.601 264.2 161.201 264.9 161.301 265.7C161.501 266.8 161.401 267.7 161.401 268.3C161.401 268.7 161.601 269.2 162.001 269.4C162.501 269.7 163.201 269.5 163.401 268.9L165.101 265.5C172.201 268.6 179.801 268.1 181.101 265.7Z"
        fill="#25383F"
      />
      <path
        d="M171.701 336.5L189.701 325.3C189.701 325.3 173.201 297.2 153.301 285L134.701 280.5C134.701 280.5 96.8008 283 77.0008 316.9L91.5008 321.3L70.8008 366C70.8008 366 130.001 377.4 131.101 377.1C143.001 374.2 139.301 354.2 139.301 354.2C139.301 354.2 153.601 323.4 155.201 324L171.701 336.5Z"
        fill="#25393F"
      />
      <path
        d="M191.6 444.4C191.6 444.4 183.1 449.1 172.4 446.7C172.4 446.7 164.6 447.5 160.5 444.2L161.3 436.8L187.5 438L191.6 444.4Z"
        fill="#25383F"
      />
      <path
        d="M60.9009 427.7C60.9009 427.7 56.8009 436.7 56.0009 445.7C56.0009 445.7 55.6009 458 59.3009 458L66.1009 455L67.5009 431L60.9009 427.7Z"
        fill="#25383F"
      />
      <path
        d="M71.7 459.3H19L52.5 434L53.1 434.7C58.7 440.8 73 443.8 73.2 443.8L74.2 444L71.7 459.3Z"
        fill="white"
      />
      <path
        d="M72.4008 460H16.8008L52.6008 432.9L53.7008 434.1C59.1008 440 73.2008 442.9 73.3008 443L75.0008 443.3L72.4008 460ZM21.2008 458.5H71.0008L73.2008 444.5L72.9008 444.4C72.8008 444.4 58.3008 441.5 52.4008 435.1L52.2008 434.9L21.2008 458.5Z"
        fill="#25383F"
      />
      <path
        d="M210.001 459.3H163.801L167.101 433.3L182.101 432.8L182.301 433.6C182.301 433.7 186.101 446.5 194.301 448.2C204.901 450.4 209.301 455.9 209.801 458.2L210.001 459.3Z"
        fill="white"
      />
      <path
        d="M210.9 460H163L166.5 432.5L182.7 431.9L183.1 433.2C183.1 433.3 186.8 445.6 194.5 447.2C205.1 449.4 210 454.9 210.6 457.8L210.9 460ZM164.6 458.5H209L208.9 458.2C208.5 456.1 204.2 450.9 194 448.7C185.4 446.9 181.5 433.8 181.5 433.6L181.4 433.4L167.7 433.9L164.6 458.5Z"
        fill="#25383F"
      />
      <path d="M79.4008 368.4L70.8008 366L80.3008 360.3L79.4008 368.4Z" fill="#F5AE2D" />
      <path
        d="M140.201 459.2L60.2012 458.8C67.8012 448.3 62.8012 430.3 62.8012 430.1L62.5012 428.8L114.301 430.4C97.4012 412 85.5012 396 81.8012 381.7C77.6012 365.7 80.4012 359.9 80.4012 359.9C79.4012 358.5 99.6012 347.4 117.501 349.9L183.401 359.1C190.801 360.4 195.901 367 195.401 374.5L190.801 442.5L189.301 441.6C186.001 439.7 181.601 438.8 176.201 438.9C169.801 439.1 163.301 441.7 163.301 441.7L161.801 442.3L163.401 389.9H126.401L150.701 422.3C161.601 439.6 158.401 448.5 153.901 453.6C150.501 457.3 145.301 459.2 140.201 459.2Z"
        fill="#DDE6E9"
      />
      <path
        d="M140.201 460L58.8008 459.6L59.7008 458.4C66.9008 448.5 62.4008 431.1 62.2008 430.4L61.6008 428.1L112.701 429.7C94.3008 409.4 84.5008 394.6 81.2008 382C77.4008 367.5 79.2008 361.2 79.7008 359.9C79.7008 359.7 79.7008 359.5 79.9008 359.2C81.7008 356.3 101.001 346.9 117.701 349.3L183.601 358.5C191.401 359.9 196.801 366.9 196.301 374.7L191.601 443.9L189.101 442.4C185.901 440.5 181.601 439.6 176.401 439.8C170.101 440 163.801 442.5 163.701 442.5L161.201 443.5L162.901 390.7H127.801L151.201 421.9C160.101 436 161.101 446.5 154.301 454.2C151.001 457.8 145.901 460 140.201 460ZM61.6008 458.1L140.201 458.5C145.501 458.5 150.201 456.6 153.201 453.2C155.501 450.6 162.501 442.7 150.001 422.8L124.801 389.2H164.101L162.501 441.2L162.901 441C163.001 441 169.501 438.3 176.101 438.2C181.601 438.1 186.101 439 189.601 441L190.001 441.3L194.501 374.5C195.001 367.4 190.101 361.2 183.101 359.9L117.301 350.7C100.601 348.3 82.9008 357.7 81.1008 359.8V359.9L80.9008 360.3C80.9008 360.4 78.3008 366.2 82.4008 381.6C85.8008 394.2 95.8008 409.2 114.801 430L116.001 431.3L63.4008 429.6L63.5008 429.9C64.0008 431.8 68.0008 447.7 61.6008 458.1Z"
        fill="#25383F"
      />
      <path
        d="M155.6 326.9C155.4 326.9 155.1 326.8 154.9 326.7L145.7 320C145.2 319.6 145 318.9 145.4 318.3C145.8 317.7 146.5 317.6 147.1 318L156.3 324.7C156.8 325.1 157 325.8 156.6 326.4C156.3 326.8 155.9 326.9 155.6 326.9Z"
        fill="#DDE6E9"
      />
      <path
        d="M126.601 390.7C126.601 390.7 126.501 390.7 126.601 390.7L116.501 389.7C106.401 388.8 99.1009 385.2 94.9009 379C94.7009 378.7 94.8009 378.2 95.1009 378C95.4009 377.8 95.9009 377.9 96.1009 378.2C100.101 384 107.001 387.4 116.601 388.2L126.601 389.1C127.001 389.1 127.301 389.5 127.301 389.9C127.301 390.4 127.001 390.7 126.601 390.7Z"
        fill="#25383F"
      />
    </svg>
  );
}
